import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { getDurationWithMessagesTooltipFormatter, mapIdsToLabels } from './chartUtils';

const OrganizationChatterAverageResponseTimeByChatterChart = ({ data, chatterLabelMap, pending }) => {
  const { categories, series, tooltipFormatter } = useMemo(
    () => ({
      categories: mapIdsToLabels(data?.chatterIds, chatterLabelMap),
      series: [
        {
          name: 'Average Response Time',
          data: data?.averageResponseTimeSeconds || [],
          messages: data?.messages || [],
        },
      ],
      tooltipFormatter: getDurationWithMessagesTooltipFormatter(),
    }),
    [data, chatterLabelMap],
  );

  return (
    <OrganizationAnalyticsBarChart
      title="Average Response Time"
      subtitle="Average response time for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select creators and chatters to load response times."
      valueType="duration"
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default OrganizationChatterAverageResponseTimeByChatterChart;
